firebird

    .config([
        '$stateProvider',
        '$urlRouterProvider',
        '$locationProvider',
        '$qProvider',
        '$translateProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider, $qProvider, $translateProvider) {
            $qProvider.errorOnUnhandledRejections(true);
            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });
            $urlRouterProvider.otherwise('');

            $translateProvider.useStaticFilesLoader({
                prefix: '/i18n/minify/',
                suffix: '.json?v=1691657577827'
            });

            $translateProvider.useSanitizeValueStrategy('sceParameters');
            $translateProvider.preferredLanguage('en-US');

            $stateProvider

                //------------------------------
                // MEETING STATES
                //------------------------------

                .state('meeting-not-found', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-not-found.html');
                        }
                    ],
                    params: { reason: '', data: '', templatePrefix: '' }
                })

                .state('meeting-not-started', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-not-started.html');
                        }
                    ],
                    params: { data: '', templatePrefix: '' }
                })

                .state('meeting-ended', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-ended.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-error', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-error.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-login', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-login.html');
                        }
                    ],
                    params: {
                        appUpdateStatus: false,
                        userAlreadyExists: false,
                        meetingAccessCode: '',
                        templatePrefix: ''
                    }
                })

                .state('meeting-show-electron', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-show-electron.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-active', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-active.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('mobile-host-login', {
                    templateProvider: [
                        'templateCache',
                        function (templateCache) {
                            return templateCache.getTemplate('mobile-host-login.html');
                        }
                    ]
                })

                .state('host-account-page', {
                    templateProvider: [
                        'templateCache',
                        function (templateCache) {
                            return templateCache.getTemplate('mobile-host-account.html');
                        }
                    ]
                })

                .state('meeting-ended-thank-you', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-ended-thank-you.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('e2ee-key-was-not-provided', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-key-was-not-provided.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('e2ee-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('e2ee-not-supported-vdi', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            let prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-not-supported-vdi.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('browser-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'browser-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('app-or-browser-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            return templateCache.getTemplate('redesign/browser-or-app-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('camaro-updating', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            return templateCache.getTemplate('redesign/camaro-updating-page-container.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('loading', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'loading.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-full', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-full.html');
                        }
                    ],
                    params: {
                        seats: 0,
                        phoneNumber: '',
                        pin: '',
                        templatePrefix: ''
                    }
                })

                .state('e2ee-meeting-full', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'e2ee-meeting-full.html');
                        }
                    ],
                    params: {
                        seats: 0,
                        templatePrefix: ''
                    }
                })

                .state('meeting-locked', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-locked.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-locked-waiting-for-approval', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-locked-waiting-for-approval.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-locked-join-request-declined', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-locked-join-request-declined.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('marquee-screenshot', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'marquee-screenshot.html');
                        }
                    ],
                    params: {
                        background: '',
                        logo: '',
                        capturing: false,
                        templatePrefix: ''
                    }
                })

                .state('change-browser', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'change-browser.html');
                        }
                    ],
                    params: {
                        meetingCode: '',
                        presenterGUID: '',
                        templatePrefix: ''
                    }
                })

                .state('meeting-unite-duplicate-login', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'meeting-unite-duplicate-login.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                //------------------------------
                // ATTENDEE & CHAT
                //------------------------------
                .state('kicked-from-meeting', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'kicked-from-meeting.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('phone-audio-not-supported', {
                    templateProvider: [
                        'templateCache',
                        '$stateParams',
                        function (templateCache, $stateParams) {
                            var prefix = '';
                            if ($stateParams.templatePrefix) {
                                prefix = $stateParams.templatePrefix;
                            }

                            return templateCache.getTemplate(prefix + 'phone-audio-not-supported.html');
                        }
                    ],
                    params: { templatePrefix: '' }
                })

                .state('meeting-active.attendee-list', {
                    views: {
                        'attendee-list': {
                            template: '<attendee-list></attendee-list>'
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.chat-client', {
                    views: {
                        'chat-client': {
                            template: '<chat-client></chat-client>'
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.presenter-chat-client', {
                    views: {
                        'presenter-chat-client': {
                            template: '<presenter-chat-client></presenter-chat-client>'
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.firepad', {
                    views: {
                        firepad: {}
                    },
                    sticky: true
                })

                //------------------------------
                // SETTINGS MODAL
                //------------------------------
                .state('meeting-active.av-settings', {
                    views: {
                        'av-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/mic-webcam-options.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.custom-branding', {
                    views: {
                        'custom-branding': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/custom-branding.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.virtual-assistant', {
                    views: {
                        'virtual-assistant': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/virtual-assistant.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.security-settings', {
                    views: {
                        'security-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/security-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.beta-settings', {
                    views: {
                        'beta-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/beta-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.general-settings', {
                    views: {
                        'general-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/general-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.advanced-settings', {
                    views: {
                        'advanced-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/advanced-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.virtual-background', {
                    views: {
                        'virtual-background': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate(
                                        'redesign/modals/virtual-background-settings.html'
                                    );
                                }
                            ]
                        }
                    },
                    sticky: true
                })

                .state('meeting-active.about-settings', {
                    views: {
                        'about-settings': {
                            templateProvider: [
                                'templateCache',
                                function (templateCache) {
                                    return templateCache.getTemplate('redesign/modals/about-settings.html');
                                }
                            ]
                        }
                    },
                    sticky: true
                });
        }
    ])

    //CONFIG CONSTANTS

    .constant('config', {
        accountManager: {
            url: '/accountmanager'
        },
        api: {
            url: 'https://api.anymeeting-qa.com'
        },
        screenSharingExtensions: {
            chrome: {
                intermediaDirect: {
                    qa: 'iddplifikpclbkdcobmccdenaecjgfjn',
                    staging: 'bofnpmofdkphjhkmmbbbdcgbjojihmln',
                    prod: 'gjlnkcjifijaeogmofjkladngkaaemec'
                },
                intermediaPLR: {
                    qa: 'lemjmehpmhappogocgopgcgdnimoonnf',
                    staging: 'cfmeaejblplpgbbedoloofagfhmhhknj',
                    prod: 'fhclidaigkfhhipiegnfljdlojgafkbo'
                },
                intermediaUB: {
                    qa: 'bacbjeklbndgponcmhnfgifmhmeikhib',
                    staging: 'hlkfapfbdnplbpkokopihkfpmhcjbcao',
                    prod: 'khokimikiadnolmpjephgikejhcnpejn'
                }
            },
            firefox: {
                intermediaDirect: {
                    qa: {
                        windows: '417703/anymeeting_screensharing_extension_qa-0.3.1-fx-windows.xpi',
                        mac: '417702/anymeeting_screensharing_extension_qa-0.3.1-fx-mac.xpi'
                    },
                    staging: {
                        windows: '417705/anymeeting_screensharing_extension_staging-0.3.0-fx-windows.xpi',
                        mac: '417704/anymeeting_screensharing_extension_staging-0.3.0-fx-mac.xpi'
                    },
                    prod: {
                        windows: '417701/anymeeting_screensharing_extension-0.3.0-fx-windows.xpi',
                        mac: '417700/anymeeting_screensharing_extension-0.3.0-fx-mac.xpi'
                    }
                }
            }
        },
        fullStory: {
            plr: {
                qa: '',
                staging: '',
                prod: ''
            },
            direct: {
                qa: 'lib/fullstory/fs.js',
                staging: '',
                prod: ''
            }
        },
        support: {
            url: 'https://support.anymeeting.com'
        },
        appStoreURLs: {
            amdirect: {
                ios: 'https://itunes.apple.com/us/app/anymeeting-free-video-conference/id1108147990?ls=1&mt=8',
                iosV35: 'itms-apps://itunes.apple.com/us/app/anymeeting-for-iphone/id822368308',
                android: 'https://play.google.com/store/apps/details?id=com.anymeeting.meetingpro',
                androidV35: 'https://play.google.com/store/apps/details?id=air.com.anymeeting.android',
                kindleV35: 'http://www.amazon.com/AnyMeeting-Inc/dp/B00CDCO17Q'
            },
            intermediaDirect: {
                //TODO: Change these after successful transfers to Intermedia accounts
                ios: 'https://itunes.apple.com/us/app/anymeeting-free-video-conference/id1108147990?ls=1&mt=8',
                android: 'https://play.google.com/store/apps/details?id=com.anymeeting.meetingpro'
            },
            intermediaPLR: {
                ios: 'https://itunes.apple.com/us/app/online-meeting/id1314134796?ls=1&mt=8',
                android: 'https://play.google.com/store/apps/details?id=net.serverdata.onlinemeeting'
            }
        },
        mobileURLSchemes: {
            amdirect: 'anymeetingmp',
            direct: 'anymeetingmp',
            plr: 'gomeet'
        },
        mobileRedirectUrls: {
            amdirect: {
                mcu: 'https://mcumobile.intermedia.net',
                sfu: 'https://sfumobile.intermedia.net',
                dynamicLink: {
                    pageLinkUrl: 'https://anymeetingapp.page.link',
                    androidId: 'net.intermedia.newmeeting',
                    iosId: 'net.intermedia.anymeeting',
                    appStoreId: '1476514359'
                }
            },
            direct: {
                mcu: 'https://mcumobile.intermedia.net',
                sfu: 'https://sfumobile.intermedia.net',
                dynamicLink: {
                    pageLinkUrl: 'https://anymeetingapp.page.link',
                    androidId: 'net.intermedia.newmeeting',
                    iosId: 'net.intermedia.anymeeting',
                    appStoreId: '1476514359'
                }
            },
            plr: {
                mcu: 'https://mcumobile.serverdata.net',
                sfu: 'https://sfumobile.serverdata.net',
                dynamicLink: {
                    pageLinkUrl: 'https://gomeet.page.link',
                    androidId: 'net.serverdata.newmeeting',
                    iosId: 'net.serverdata.onlinemeetingsfu',
                    appStoreId: '1494540201'
                }
            },
            univergeblue: {
                // We point both to sfu version, since webinar is not supported for Rambo
                mcu: 'https://sfumobile.univerge.blue',
                sfu: 'https://sfumobile.univerge.blue',
                dynamicLink: {
                    pageLinkUrl: 'https://meetuniverge.page.link',
                    androidId: 'com.necam.mobilemeetings',
                    iosId: 'com.necam.mobilemeetings',
                    appStoreId: '1502380837'
                }
            }
        },
        version: 'qa3-ANYAM-108440-5',
        vertoEnabled: true,
        webinar: {
            enabled: false,
            holdMusic: '/sounds/Webinar-Hold-Music.mp3',
            reactionsAnimation: true,
            handout: false,
            edgeServerRolloutMaxDigit: 9 //must be betweeen 0-9, or -1 to disable
        },
        // extracted to config.service.ts
        resellerId: {
            qa: {
                intermediaDirect: 100351,
                intermediaPLR: 100354,
                intermediaUB: 100372
            },
            staging: {
                intermediaDirect: 100366,
                intermediaPLR: 100369,
                intermediaUB: 100375
            },
            prod: {
                intermediaDirect: 100384,
                intermediaPLR: 100393,
                intermediaUB: 100396
            }
        },
        appInsights: {
            qa: {
                instrumentationKey: 'b98a5829-4c86-4e70-9355-4fb3249f3727',
                metricThresholds: {
                    cpu: 0,
                    memory: 0,
                    gpu: 0,
                    gpuMemory: 0
                }
            },
            staging: {
                instrumentationKey: 'e865022a-5630-4a8b-9061-3018d104762f',
                metricThresholds: {
                    cpu: 0,
                    memory: 0,
                    gpu: 0,
                    gpuMemory: 0
                }
            },
            prod: {
                instrumentationKey: '9536cba1-5ab7-4cd2-ba94-2baa0faa447f',
                metricThresholds: {
                    cpu: 0,
                    memory: 0,
                    gpu: 0,
                    gpuMemory: 0
                }
            }
        },
        clientElectronDetect: {
            qa: true,
            staging: true,
            prod: true
        },
        enableOneOnOnePIP: {
            qa: true,
            staging: false,
            prod: false
        },
        isWebinarLocalizationEnabled: {
            qa: true,
            staging: true,
            prod: true
        },
        camaroVulnerabilityFixed: {
            direct: {
                qa: true,
                staging: true,
                prod: true
            },
            amdirect: {
                qa: true,
                staging: true,
                prod: true
            },
            plr: {
                qa: true,
                staging: true,
                prod: true
            },
            univergeblue: {
                qa: true,
                staging: true,
                prod: true
            }
        },
        uniteWithoutAuthReleased: {
            direct: {
                qa: true,
                staging: true,
                prod: true
            },
            amdirect: {
                qa: true,
                staging: true,
                prod: true
            },
            plr: {
                qa: true,
                staging: true,
                prod: true
            },
            univergeblue: {
                qa: true,
                staging: true,
                prod: true
            }
        },
        themedFeaturesStartDate: '2022-12-1',
        themedFeaturesEndDate: '2023-1-15'
    });
